import {
  Button,
  Input,
  InputFile,
  Form,
  ModalFooter,
} from "@telluscompany/design-system";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { createDocumentSchema, DocumentUploadFormData } from "../../schemas";
import { useLocalization } from "@i18n";

interface UploadDocumentModalProps {
  onSubmit: (data: DocumentUploadFormData) => void;
  onCancel: () => void;
}

export const UploadDocumentModal = ({
  onSubmit,
  onCancel,
}: UploadDocumentModalProps) => {
  const { translate } = useLocalization();

  const form = useForm<DocumentUploadFormData>({
    resolver: zodResolver(createDocumentSchema(translate)),
    defaultValues: {
      version: "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="px-[32px] py-[16px]">
          <div className="grid grid-cols-2 gap-4">
            <InputFile
              control={form.control}
              label={translate("management.releaseNotes.form.label.file")}
              name="file"
              maxFiles={1}
            />
            <Input
              control={form.control}
              label={translate("management.releaseNotes.form.label.version")}
              name="version"
              type="text"
              placeholder={translate(
                "management.releaseNotes.form.placeholder.version",
              )}
            />
          </div>
        </div>
        <ModalFooter
          footer={
            <Button type="submit" variant="primary">
              {translate("management.releaseNotes.button.save")}
            </Button>
          }
          closeModal={
            <Button type="button" variant="secondary" onClick={onCancel}>
              {translate("management.releaseNotes.button.cancel")}
            </Button>
          }
        />
      </form>
    </Form>
  );
};
